<template>
    <div class="tyn-root">
        <Header></Header>

        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Gerenciamento de Usuários</h1>
                                    <p class="modern-subtitle">Gerencie permissões e acesso dos usuários do sistema</p>
                                </div>
                            </div>
                        </div>
                    </div><!-- modern-header -->
                    <div class="container pt-4">
                        <div class="row mb-4" v-if="isLoading">
                            <div class="col-12 text-center my-5">
                                <div class="loading-spinner">
                                    <i class="fas fa-spinner fa-spin fa-3x"></i>
                                    <p class="mt-3">Carregando usuários...</p>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="contrato != null" class="tabs-header d-flex align-items-center justify-content-center px-3 mt-3">
                                <ul class="nav nav-tabs my-2 flex-grow-1" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link"
                                                :class="{ active: abaSelecionada === 'usuarios' }"
                                                @click="abaSelecionada = 'usuarios'"
                                                type="button">
                                            Gerenciamento de Usuários
                                        </button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link"
                                                :class="{ active: abaSelecionada === 'assinaturas' }"
                                                @click="abaSelecionada = 'assinaturas'"
                                                type="button">
                                            Assinatura Eletrônica
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div class="row mb-4 px-4">
                                <template v-if="contrato != null">
                                    <div v-if="abaSelecionada === 'usuarios' || isContratoZero">
                                        <div class="modern-table-card" v-if="lstContratos.length > 1">
                                            <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                                <div class="header-group">
                                                    <div class="header-icon">
                                                        <i class="fas fa-file-alt"></i>
                                                    </div>
                                                    <div>
                                                        <span class="header-label">Contrato</span>
                                                        <h4 class="header-title">Licença de referência</h4>
                                                    </div>
                                                </div>
                                                <select class="form-control select-contrato" v-model="idContrato" id="idContratoReferencia" @change="getDadosGerenciamento()">
                                                    <option v-for="(item,index) in lstContratos" :key="index" :value="item.idContratoGnp">
                                                        Contrato - {{item.nrContrato}}/{{item.nrAno}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <!-- TOTAIS -->
                                        <div class="col-12 card-totais my-3" v-if="!isContratoZero">
                                            <div class="row align-items-center">
                                                <div class="col-12 col-md-9">
                                                    <div class="row align-items-start d-flex p-2">
                                                        <div class="col-12 col-lg-6">
                                                            <template v-for="(item,index) in lstProdutos.slice(0,6)">
                                                                <template v-for="(item2,index2) in dados.lstTotaisProdutos">
                                                                    <div class="produto-stat" v-if="item.idProduto == item2.idProduto" :key="index+'-'+index2">
                                                                        <i class="fas fa-check-circle me-2"></i>
                                                                        <span class="produto-nome">{{item.nmProduto}}:</span>
                                                                        <span class="produto-valor">{{item2.msg}}</span>
                                                                    </div>
                                                                </template>
                                                            </template>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <template v-for="(item,index) in lstProdutos.slice(6,lstProdutos.length)">
                                                                <template v-for="(item2,index2) in dados.lstTotaisProdutos">
                                                                    <div class="produto-stat" v-if="item.idProduto == item2.idProduto" :key="index+'-'+index2">
                                                                        <i class="fas fa-check-circle me-2"></i>
                                                                        <span class="produto-nome">{{item.nmProduto}}:</span>
                                                                        <span class="produto-valor">{{item2.msg}}</span>
                                                                    </div>
                                                                </template>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-3 text-center total-usuarios-section">
                                                    <div class="total-usuarios-card">
                                                        <i class="fas fa-users mb-2"></i>
                                                        <span class="total-label">Total de Usuários</span>
                                                        <h2 class="total-number">{{dados.totalUsuarios}}</h2>
                                                        <button class="btn btn-primary btn-novo-usuario" @click="addUsuarioCliente(1,null,contrato.idContrato,contrato.idCliente)" v-if="contrato.idContrato == user.usuario.idContrato && isAdminAndSupervisor">
                                                            <i class="fas fa-plus me-2"></i>
                                                            Novo Usuário
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- GESTOR -->
                                        <div class="col-12 card-gestor my-3" v-if="!isContratoZero && dados?.dadosSupervisor && dados.dadosSupervisor.usuario">
                                            <div class="gestor-header">
                                                <div class="gestor-info">
                                                    <div class="gestor-avatar">
                                                        <i class="fas fa-user-shield"></i>
                                                    </div>
                                                    <div class="gestor-details">
                                                        <h3 class="gestor-nome">{{dados.dadosSupervisor.usuario.nmUsuario}}</h3>
                                                        <span class="label-gestor">
                                                            <i class="fas fa-crown me-1"></i>
                                                            Gestor de Contrato
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="gestor-actions d-flex gap-2" v-if="contrato.dsLoginSupervisor == user.usuario.dsLogin">
                                                    <button type="button"
                                                            class="btn-edit-gestor"
                                                            @click="addUsuarioCliente(2, dados.dadosSupervisor.usuario.dsLogin, contrato.idContrato, contrato.idCliente)"
                                                            title="Editar gestor">
                                                        <i class="fas fa-pencil-alt"></i>
                                                    </button>
                                                    <button type="button"
                                                            class="btn-edit-gestor"
                                                            @click="gerirCertificados(2, dados.dadosSupervisor.usuario.dsLogin, contrato.idContrato, contrato.idCliente)"
                                                            title="Gerir certificados">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                            <path d="M13 21L15 20L17 21V14H13M17 9V7L15 8L13 7V9L11 10L13 11V13L15 12L17 13V11L19 10M20 3H4A2 2 0 0 0 2 5V15A2 2 0 0 0 4 17H11V15H4V5H20V15H19V17H20A2 2 0 0 0 22 15V5A2 2 0 0 0 20 3M11 8H5V6H11M9 11H5V9H9M11 14H5V12H11Z" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="gestor-footer">
                                                <i class="fas fa-info-circle me-2"></i>
                                                <span>Este usuário possui todas as permissões</span>
                                            </div>
                                        </div>

                                        <!-- USUARIOS -->
                                        <div class="col-12 my-3 p-0" v-if="!isContratoZero && (!usuarios || usuarios.length === 0)">
                                            <div class="col-12 text-center my-5">
                                                <div class="empty-state">
                                                    <i class="fas fa-users fa-4x mb-3"></i>
                                                    <p class="empty-message">Nenhum usuário encontrado!</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12 my-3 p-0">
                                            <div class="row">
                                                <div class="col-12" v-for="(item, index) in usuarios" :key="index">
                                                    <div class="card-usuario">
                                                        <div class="usuario-header">
                                                            <div class="usuario-info">
                                                                <div class="usuario-avatar">
                                                                    <i class="fas fa-user"></i>
                                                                </div>
                                                                <div>
                                                                    <h3 class="usuario-nome">{{ item.nmUsuario }}</h3>

                                                                    <!-- Badge de administrador -->
                                                                    <span v-if="item.flAdministrador === 'Sim'" class="label-admin">
                                                                        <i class="fas fa-user-shield me-1"></i>
                                                                        Administrador do Contrato
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div class="usuario-actions" v-if="contrato.idContrato == user.usuario.idContrato && isAdminAndSupervisor">
                                                                <button type="button" class="btn-action btn-edit" @click="addUsuarioCliente(2,item.dsLogin,item.idContrato,item.idCliente)" title="Editar usuário">
                                                                    <i class="fas fa-pencil-alt"></i>
                                                                </button>
                                                                <button type="button" class="btn-action btn-edit" @click="gerirCertificados(2,item.dsLogin,item.idContrato,item.idCliente)" title="Editar usuário">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> <path d="M13 21L15 20L17 21V14H13M17 9V7L15 8L13 7V9L11 10L13 11V13L15 12L17 13V11L19 10M20 3H4A2 2 0 0 0 2 5V15A2 2 0 0 0 4 17H11V15H4V5H20V15H19V17H20A2 2 0 0 0 22 15V5A2 2 0 0 0 20 3M11 8H5V6H11M9 11H5V9H9M11 14H5V12H11Z" /></svg>
                                                                </button>
                                                                <button type="button" class="btn-action btn-delete" @click="excluirUsuarioContrato(item)" title="Excluir usuário">
                                                                    <i class="fas fa-trash-alt"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="usuario-divider"></div>
                                                        <div class="usuario-permissoes">
                                                            <h4 class="permissoes-title">
                                                                <i class="fas fa-key me-2"></i>
                                                                Permissões de Acesso
                                                            </h4>
                                                            <div class="row">
                                                                <div class="col-12 col-md-6 mb-3" v-for="(itemProduto,index2) in item.lstProdutoClienteUsuarioProduto" :key="index2">
                                                                    <div class="permissao-item">
                                                                        <label class="permissao-checkbox" :for="index+'_'+ item.idCliente + '_' + item.idContrato + '_' + itemProduto.produto.idProduto">
                                                                            <input v-model="itemProduto.flPossuiProduto"
                                                                                   type="checkbox"
                                                                                   :id="index+'_'+ item.idCliente + '_' + item.idContrato + '_' + itemProduto.produto.idProduto"
                                                                                   :disabled="item.flAdministrador === 'Sim' || item.idContrato != user.usuario.idContrato || !isAdminAndSupervisor"
                                                                                   @click="(item.flAdministrador !== 'Sim' && contrato.idContrato == user.usuario.idContrato && isAdminAndSupervisor) && changePermission(item, itemProduto)" />
                                                                            <span class="checkbox-custom"></span>
                                                                            <span class="produto-label" :style="'color: #'+itemProduto.produto.nrCor">
                                                                                <i class="fas fa-box me-2"></i>
                                                                                {{itemProduto.produto.nmProduto.replace(" de ", " ")}}
                                                                            </span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>


                                <div class="col-12 my-3 p-0">
                                    <div v-if="abaSelecionada === 'assinaturas' || isContratoZero">
                                        <div class="modern-table-card">
                                            <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                                <div class="header-group">
                                                    <div class="header-icon">
                                                        <i class="fas fa-file-signature"></i>
                                                    </div>
                                                    <div>
                                                        <span class="header-label">Assinatura Eletrônica</span>
                                                        <h4 class="header-title">Pessoas para Assinatura</h4>
                                                    </div>
                                                </div>
                                                <button class="modern-btn modern-btn-primary" @click="novoAssinanteExterno()">
                                                    <i class="fas fa-plus me-2"></i>
                                                    Nova Pessoa
                                                </button>
                                            </div>

                                            <div class="modern-table-content">
                                                <div v-if="isLoadingAssinantes" class="modern-table-state loading">
                                                    <i class="fas fa-spinner fa-spin"></i>
                                                    <p>Carregando assinantes…</p>
                                                </div>

                                                <div v-else-if="assinantes.length === 0" class="modern-table-state empty">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 16 16" fill="currentColor">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                    </svg>
                                                    <h5>Nenhum assinante externo cadastrado</h5>
                                                    <p>Registre certificados ao contrato para os fluxos de assinatura.</p>
                                                </div>

                                                <div v-else class="table-wrapper">
                                                    <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                                        <thead>
                                                            <tr>
                                                                <th>Nome</th>
                                                                <th>Email</th>
                                                                <th class="text-center">Ativo</th>
                                                                <th class="text-center" style="white-space: nowrap; width: 1%;">Ações</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="a in assinantes" :key="a.idPessoa">
                                                                <td data-label="Nome">
                                                                    <span class="assinante-nome">{{ a.nmPessoa }}</span>
                                                                </td>
                                                                <td data-label="Email">
                                                                    <span class="assinante-email">{{ a.dsEmail }}</span>
                                                                </td>
                                                                <td data-label="Ativo" class="text-center">
                                                                    <span class="badge-status" :class="a.flCertAtivo ? 'badge-ativo' : 'badge-inativo'">
                                                                        {{ a.flCertAtivo ? 'Sim' : 'Não' }}
                                                                    </span>
                                                                </td>
                                                                <td data-label="Ações" class="text-end">
                                                                    <div class="action-buttons justify-end">
                                                                        <button class="action-btn action-btn-view" @click="editarAssinanteExterno(a)" title="Editar">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-9.5 9.5-3.5.5a.5.5 0 0 1-.574-.574l.5-3.5 9.5-9.5zM11.207 2.5 3 10.707V13h2.293L13.5 4.793 11.207 2.5zm1.586-1.586L13 1.707 14.293.414 12.793-.086z" />
                                                                            </svg>
                                                                            <span class="action-text">Editar</span>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div><!-- .container pt-4 -->
                </div><!-- .tyn-section -->
            </div><!-- .tyn-main -->
        </div><!-- .tyn-content -->
        <div class="tyn-footer border-top">
            <div class="bg-white text-center py-3">
                <p class="mb-0 small">
                    &copy; 2025 <a style="color: unset" target="_blank" href="https://sollai.com.br/"> SollAI | Inteligencia Artificial </a>.
                </p>
            </div>
        </div><!-- .tyn-footer -->
        <!-- MODAIS HEADER -->
        <Modais></Modais>

        <CadatroUsuarioCliente :showModal="showModalUsuario" :dados="usuarioCrud" @reload="() => { load(); }" @close="showModalUsuario = false"></CadatroUsuarioCliente>
        <CadastroCertificadoAssinatura :showModal="showModalCertificado"
                                       :dados="usuarioCrud"
                                       :alvo="alvoCertificado"
                                       :emails-internos="emailsUsuariosInternos"
                                       @reload="() => { loadAssinantesExternos(); }"
                                       @close="showModalCertificado = false" />
    </div><!-- .tyn-root -->
</template>

<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'

    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import Swal from 'sweetalert2'
    import CadatroUsuarioCliente from '@/components/CadatroUsuarioCliente'
    import CadastroCertificadoAssinatura from '@/components/CadastroCertificadoAssinatura'


    export default {
        name: 'GerenciarUsuarios',
        components: { Header, Modais, CadatroUsuarioCliente, CadastroCertificadoAssinatura },
        computed: {
            isAdmContrato() {
                return this.$store.state.isAdmContrato
            },

            isContratoZero() {
                return this.$store.state.user.usuario.idContrato === 0;
            },

            isAdminAndSupervisor() {
                return this.isAdmContrato || this.user.usuarioApi.flAdministrador;
            },

            currentIdCliente() {
                return this.contrato?.idCliente
                    ?? this.$store.state.user?.usuario?.idCliente
                    ?? (this.isContratoZero ? 0 : null);
            },
            user() {
                return this.$store.state.user
            },
            emailsUsuariosInternos() {
                const normalizar = (e) => (e || '').trim().toLowerCase();

                const base = (this.usuarios || [])
                    .map(u => normalizar(u.dsEmail))
                    .filter(e => !!e);

                const extras = (this.extraEmailsInternos || [])
                    .map(normalizar)
                    .filter(e => !!e && !base.includes(e));

                return [...base, ...extras];
            },
        },
        data: function () {
            return {
                usuarios: [],
                abaSelecionada: 'usuarios',
                contrato: null,
                lstProdutos: [],
                dados: null,
                isLoading: true,
                showModalUsuario: false,
                showModalCertificado: false,
                usuarioCrud: { dsLogin: null },
                assinantes: [],
                isLoadingAssinantes: false,
                filtroAssinante: '',
                alvoCertificado: 'usuario',
                extraEmailsInternos: [],
                lstContratos: [],
                idContrato: null,
            }
        },
        methods: {

            load() {
                let $this = this;
                if (!$this.isContratoZero) {
                    $this.getContratos();
                } else {
                    $this.isLoading = false;
                    $this.loadAssinantesExternos();
                    return;
                }
                
            },
            getContratos() {
                let $this = this;
                axios.get(`${urlApi}/ClienteContratoProduto/GetContratos/`, { loading: false, params: {  } })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.lstContratos = result;
                            
                            if ($this.lstContratos.length > 0) {
                                for (let i = 0; i < $this.lstContratos.length; i++) {
                                    if ($this.lstContratos[i].dsLoginSupervisor == $this.user.usuario.dsLogin) {
                                        $this.idContrato = $this.lstContratos[i].idContratoGnp;
                                    }
                                }
                                if ($this.idContrato == null) {
                                    $this.idContrato = $this.lstContratos[0].idContratoGnp;
                                }                                
                            }
                            $this.getDadosGerenciamento();
                        } else {
                            avisoErro("Não foi possível carregar os contratos.");
                        }
                    })
                    .catch(res => {
                        if (res.response.status == 403) {
                            avisoErro("Você não tem acesso a esse produto.");
                            setTimeout(() => window.location.href = "/HomeLogado", 2000);
                        } else {
                            avisoErro(res.response?.data || res.response.statusText);
                        }
                    });
            },

            getDadosGerenciamento() {
                let $this = this;
                $this.isLoading = true;

                if ($this.isContratoZero) {
                    $this.isLoading = false;
                    $this.loadAssinantesExternos();
                    return;
                }

                axios.get(`${urlApi}/ClienteContratoProduto/GetDadosGerenciamento/`, { loading: false, params: { idContrato: $this.idContrato } })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.contrato = result.contrato;
                            $this.lstProdutos = result.lstProdutos;
                            $this.dados = result.dados;
                            $this.usuarios = result.lstUsuarioClienteLista || [];
                            $this.carregarInfoAdminUsuarios();
                            $this.loadAssinantesExternos();
                        } else {
                            avisoErro("Não foi possível carregar os usuários.");
                        }
                    })
                    .catch(res => {
                        if (res.response?.status == 403) {
                            avisoErro("Você não tem acesso a esse produto.");
                            setTimeout(() => window.location.href = "/HomeLogado", 2000);
                        } else {
                            avisoErro(res.response?.data || res.response?.statusText || "Erro ao carregar");
                        }
                    })
                    .finally(() => {
                        $this.isLoading = false;
                    });
            },

            carregarInfoAdminUsuarios() {
                let $this = this;
                if (!$this.usuarios || !$this.usuarios.length) return;
                $this.extraEmailsInternos = [];
                $this.usuarios.forEach(usuario => {
                    const params = {
                        dsLogin: usuario.dsLogin,
                        idContrato: usuario.idContrato,
                        idCliente: usuario.idCliente,
                    };

                    axios.get(`${urlApi}/ClienteContratoProduto/GetCadastroUsuarioCliente`, { params })
                        .then(res => {
                            if (res.data.success) {
                                const result = res.data.data;
                                const clienteUsuario = result.clienteUsuario;
                                const pessoaCrud = result.pessoaCrud;

                                if (clienteUsuario) {
                                    if (typeof $this.$set === 'function') {
                                        $this.$set(usuario, 'flAdministrador', clienteUsuario.flAdministrador);
                                    } else {
                                        usuario.flAdministrador = clienteUsuario.flAdministrador;
                                    }
                                    if (clienteUsuario.flAdministrador === 'Sim') {
                                        $this.ensureAdminPermissionsForUser(usuario);
                                    }
                                }

                                if (pessoaCrud && pessoaCrud.dsEmail) {
                                    if (typeof $this.$set === 'function') {
                                        $this.$set(usuario, 'dsEmail', pessoaCrud.dsEmail);
                                    } else {
                                        usuario.dsEmail = pessoaCrud.dsEmail;
                                    }
                                }
                            } else {
                                console.error('Não foi possível carregar dados para', usuario.dsLogin);
                            }
                        })
                        .catch(err => {
                            console.error('Erro ao buscar cadastro do usuário', usuario.dsLogin, err);
                        });
                });

                if ($this.dados && $this.dados.dadosSupervisor && $this.dados.dadosSupervisor.usuario) {
                    const sup = $this.dados.dadosSupervisor.usuario;

                    const paramsSup = {
                        dsLogin: sup.dsLogin,
                        idContrato: $this.contrato?.idContrato,
                        idCliente: $this.contrato?.idCliente,
                    };

                    axios.get(`${urlApi}/ClienteContratoProduto/GetCadastroUsuarioCliente`, { params: paramsSup })
                        .then(res => {
                            if (!res.data?.success || !res.data?.data) {
                                console.error('Não foi possível carregar dados do gestor', sup.dsLogin);
                                return;
                            }

                            const pessoaCrud = res.data.data.pessoaCrud;
                            if (pessoaCrud && pessoaCrud.dsEmail) {
                                const email = pessoaCrud.dsEmail;
                                if (typeof $this.$set === 'function') {
                                    $this.$set(sup, 'dsEmail', email);
                                } else {
                                    sup.dsEmail = email;
                                }
                                if (!$this.extraEmailsInternos) {
                                    $this.extraEmailsInternos = [];
                                }
                                if (!$this.extraEmailsInternos.includes(email)) {
                                    $this.extraEmailsInternos.push(email);
                                }
                            }
                        })
                        .catch(err => {
                            console.error('Erro ao buscar dados do gestor', sup.dsLogin, err);
                        });
                }
            },

            changePermission(usuario, produto) {
                var $this = this;
                var url = produto.flPossuiProduto ? 'RemoverPermissao' : 'AdicionarPermissao';
                var params = {
                    idCliente: usuario.idCliente,
                    idContrato: usuario.idContrato,
                    dsLogin: usuario.dsLogin,
                    idProduto: produto.produto.idProduto,
                };

                axios.post(`${urlApi}/ClienteContratoProduto/${url}/`, params)
                    .then(res => {
                        if (res.data.success) {
                            $this.getTotalUsuariosProduto(usuario.idCliente, produto.produto.idProduto, usuario.idContrato);
                            avisoToast("Permissão editada com sucesso!");
                        } else {
                            avisoErro("Não foi possível editar a permissão.");
                            if (url === 'RemoverPermissao') {
                                produto.flPossuiProduto = true;
                            } else {
                                produto.flPossuiProduto = false;
                            }
                        }
                    })
                    .catch(res => {
                        if (res.response?.data) {
                            avisoErro(res.response.data.errors ? res.response.data.errors[0] : res.response.data);
                            if (url === 'RemoverPermissao') {
                                produto.flPossuiProduto = true;
                            } else {
                                produto.flPossuiProduto = false;
                            }
                        } else {
                            avisoErro("Erro ao gravar permissão");
                        }
                    });
            },

            ensureAdminPermissionsForUser(usuario) {
                let $this = this;

                if (!usuario || usuario.flAdministrador !== 'Sim') return;
                if (!Array.isArray(usuario.lstProdutoClienteUsuarioProduto)) return;

                usuario.lstProdutoClienteUsuarioProduto.forEach(itemProduto => {
                    if (!itemProduto.flPossuiProduto) {
                        $this.addAdminPermission(usuario, itemProduto);
                    }
                });
            },

            addAdminPermission(usuario, itemProduto) {
                let $this = this;
                const params = {
                    idCliente: usuario.idCliente,
                    idContrato: usuario.idContrato,
                    dsLogin: usuario.dsLogin,
                    idProduto: itemProduto.produto.idProduto,
                };

                axios.post(`${urlApi}/ClienteContratoProduto/AdicionarPermissao/`, params)
                    .then(res => {
                        if (res.data.success) {
                            itemProduto.flPossuiProduto = true;

                            $this.getTotalUsuariosProduto(usuario.idCliente, itemProduto.produto.idProduto, usuario.idContrato);
                        } else {
                            avisoErro("Não foi possível editar a permissão do administrador.");
                        }
                    })
                    .catch(res => {
                        if (res.response?.data?.errors?.length) {
                            avisoErro(res.response.data.errors[0]);
                        } else {
                            avisoErro(res.response?.statusText || "Erro ao gravar permissão do administrador.");
                        }
                    });
            },

            getTotalUsuariosProduto(idCliente, idProduto, idContrato) {
                let $this = this;
                var params = {
                    idCliente: idCliente,
                    idContrato: idContrato,
                    idProduto: idProduto,
                }
                axios.get(`${urlApi}/ClienteContratoProduto/GetTotalUsuariosProduto/`, { params: params })
                    .then(res => {
                        if (res.data.success) {
                            var pos = $this.dados.lstTotaisProdutos.map(function (e) { return e.idProduto }).indexOf(idProduto);
                            $this.dados.lstTotaisProdutos[pos].msg = res.data.data;
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de utilizações.");
                        }

                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },


            addUsuarioCliente(cdOperacao, dsLogin, idContrato, idCliente) {
                switch (cdOperacao) {
                    // inserir
                    case 1:
                        this.usuarioCrud = { dsLogin: null, idContrato: idContrato, idCliente: idCliente };
                        this.showModalUsuario = !this.showModalUsuario;
                        break;
                    // alterar
                    case 2:
                        this.usuarioCrud = { dsLogin: dsLogin, idContrato: idContrato, idCliente: idCliente };
                        this.showModalUsuario = !this.showModalUsuario;
                        break;
                    // excluir
                    case 3:
                        break;
                }
            },

            gerirCertificados(cdOperacao, dsLogin, idContrato, idCliente) {
                switch (cdOperacao) {
                    case 1:
                        this.alvoCertificado = 'usuario';
                        this.usuarioCrud = { dsLogin: null, idContrato, idCliente };
                        this.showModalCertificado = !this.showModalCertificado;
                        break;
                    case 2:
                        this.alvoCertificado = 'usuario';
                        this.usuarioCrud = { dsLogin, idContrato, idCliente };
                        this.showModalCertificado = !this.showModalCertificado; 
                        break;
                    case 3:
                        break;
                }
            },

            excluirUsuarioContrato(usuario) {
                let $this = this;
                Swal.fire({
                    title: 'Confirmar a exclusão do usuário "' + usuario.nmUsuario + '"?',
                    showDenyButton: true,
                    //showCancelButton: true,
                    confirmButtonText: 'Sim',
                    denyButtonText: 'Não',
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/ClienteContratoProduto/ExcluirUsuarioContrato/`, { idCliente: usuario.idCliente, idContrato: usuario.idContrato, dsLogin: usuario.dsLogin })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Usuário excluido com sucesso!")
                                    $this.usuarios = $this.usuarios.filter(function (elm) { return (elm.dsLogin != usuario.dsLogin) });
                                    $this.getDadosGerenciamento();
                                } else {
                                    avisoErro("Não foi possível excluir o usuário.");
                                }

                            })
                            .catch(res => {
                                if (res.data != undefined) {
                                    avisoErro(res.response.data);
                                } else {
                                    avisoErro(res.response.statusText);
                                }
                            });
                    }
                })
            },

            loadAssinantesExternos() {
                let $this = this;

                const isInterno = $this.isContratoZero === true;
                const idCliente = isInterno ? 0 : $this.currentIdCliente;

                if (!isInterno && !idCliente) {
                    avisoErro("Não foi possível identificar o cliente para listar os assinantes externos.");
                    return;
                }

                $this.isLoadingAssinantes = true;

                axios.get(`${urlApi}/Pessoa/GetExterno`, { params: { idCliente } })
                    .then(res => {
                        if (res.data.success) {
                            const rows = res.data.data.rows || [];
                            const arr = Array.isArray(rows) ? rows : Object.values(rows);
                            $this.assinantes = arr.map(r => r?.pessoa ?? r).map(p => ({
                                idPessoa: p.idPessoa,
                                nmPessoa: p.nmPessoa,
                                dsEmail: p.dsEmail,
                                dsLogin: p.dsLogin,
                                flCertAtivo: p.flCertAtivo,
                            }));
                        } else {
                            avisoErro("Não foi possível carregar os assinantes externos.");
                        }
                    })
                    .catch(res => {
                        avisoErro(res.response?.data || res.response?.statusText || "Erro ao carregar assinantes externos.");
                    })
                    .finally(() => {
                        $this.isLoadingAssinantes = false;
                    });
            },

            novoAssinanteExterno() {
                this.alvoCertificado = 'externo';
                this.usuarioCrud = {
                    idPessoa: null,
                    dsLogin: null,
                    idContrato: this.contrato?.idContrato ?? 0,
                    idCliente: this.currentIdCliente,
                };
                this.showModalCertificado = !this.showModalCertificado;
            },

            editarAssinanteExterno(a) {
                this.alvoCertificado = 'externo';
                this.usuarioCrud = {
                    idPessoa: a.idPessoa,
                    dsLogin: a.dsLogin,
                    idCliente: this.currentIdCliente,
                };
                this.showModalCertificado = !this.showModalCertificado;
            },
          
        },
        mounted() {
            if (this.isAdmContrato != 'Sim' && !this.isContratoZero && !this.user?.usuarioApi?.flAdministrador) {
                this.$router.push({ name: 'Home' });
                return;
            }

            this.load();
        },

        watch: {
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    /* Animações */
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes pulse {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.05);
        }
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    /* Header Moderno */
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
    }

    .title-section {
        flex: 1;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    @media (max-width: 768px) {
        .modern-header {
            padding: 24px 0;
        }

        .header-content {
            flex-direction: column;
            text-align: center;
        }

        .modern-title {
            font-size: 28px;
        }

        .modern-subtitle {
            font-size: 13px;
        }
    }

    /* Loading Spinner */
    .loading-spinner {
        animation: fadeInUp 0.5s ease-out;

        i {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }

        p {
            color: #6c757d;
            font-weight: 500;
            font-size: 1.1rem;
        }
    }

    /* Card Totais */
    .card-totais {
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
        border-radius: 12px;
        padding: 1.25rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(31, 123, 255, 0.1);
        transition: all 0.3s ease;
        animation: fadeInUp 0.6s ease-out 0.1s backwards;

        &:hover {
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
            border-color: rgba(31, 123, 255, 0.2);
        }

        @media (max-width: 768px) {
            padding: 1rem;
        }
    }

    .produto-stat {
        display: flex;
        align-items: center;
        padding: 0.5rem 0;
        transition: all 0.3s ease;

        i {
            color: #00d084;
            font-size: 0.875rem;
        }

        .produto-nome {
            font-weight: 600;
            color: #2d3748;
            margin-right: 0.5rem;
            font-size: 0.875rem;
        }

        .produto-valor {
            font-weight: 700;
            color: #1f7bff;
            font-size: 0.875rem;
        }

        &:hover {
            transform: translateX(5px);

            .produto-valor {
                color: #00d084;
            }
        }
    }

    .total-usuarios-section {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;

        @media (max-width: 768px) {
            margin-top: 2rem;
        }
    }

    .total-usuarios-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;

        i.fa-users {
            font-size: 2rem;
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            animation: pulse 2s ease-in-out infinite;
        }

        .total-label {
            font-size: 0.8rem;
            color: #6c757d;
            font-weight: 600;
            margin-bottom: 0.25rem;
        }

        .total-number {
            font-size: 2.5rem;
            font-weight: 800;
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            margin: 0.25rem 0 1rem 0;
            line-height: 1;
        }
    }

    .btn-novo-usuario {
        width: 100%;
        padding: 0.625rem 1rem;
        border-radius: 10px;
        font-weight: 600;
        font-size: 0.875rem;
        background: linear-gradient(135deg, #1f7bff 0%, #0056d2 100%);
        border: none;
        box-shadow: 0 4px 12px rgba(31, 123, 255, 0.3);
        transition: all 0.3s ease;

        &:hover {
            background: linear-gradient(135deg, #0056d2 0%, #003d99 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(31, 123, 255, 0.4);
        }

        &:active {
            transform: translateY(0);
        }
    }

    /* Card Gestor */
    .card-gestor {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 249, 250, 0.95) 100%);
        backdrop-filter: blur(10px);
        border-radius: 12px;
        padding: 1.25rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(255, 193, 7, 0.3);
        transition: all 0.3s ease;
        animation: fadeInUp 0.6s ease-out 0.2s backwards;
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 3px;
            background: linear-gradient(90deg, #ffc107 0%, #ff9800 100%);
        }

        &:hover {
            box-shadow: 0 6px 20px rgba(255, 193, 7, 0.15);
            border-color: rgba(255, 193, 7, 0.5);
        }

        @media (max-width: 768px) {
            padding: 1rem;
        }
    }

    .gestor-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;

        @media (max-width: 576px) {
            flex-wrap: wrap;
            gap: 0.75rem;
        }
    }

    .gestor-info {
        display: flex;
        align-items: center;
        gap: 1rem;
        flex: 1;
    }

    .gestor-avatar {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);
        flex-shrink: 0;

        i {
            font-size: 1.35rem;
            color: white;
        }
    }

    .gestor-details {
        display: flex;
        flex-direction: column;
        gap: 0.375rem;
    }

    .gestor-nome {
        font-size: 1.1rem;
        font-weight: 700;
        color: #2d3748;
        margin: 0;
        line-height: 1.2;
    }

    .label-gestor {
        display: inline-flex;
        align-items: center;
        padding: 0.375rem 0.75rem;
        border-radius: 16px;
        background: linear-gradient(135deg, #1f7bff 0%, #0056d2 100%);
        color: white;
        font-weight: 600;
        font-size: 0.75rem;
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.25);
        white-space: nowrap;

        i {
            animation: pulse 2s ease-in-out infinite;
        }
    }

    .btn-edit-gestor {
        width: 36px;
        height: 36px;
        border-radius: 10px;
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
        border: 2px solid #e9ecef;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        cursor: pointer;
        flex-shrink: 0;

        i {
            color: #1f7bff;
            font-size: 0.95rem;
        }

        &:hover {
            background: linear-gradient(135deg, #1f7bff 0%, #0056d2 100%);
            border-color: #1f7bff;
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.3);
            transform: translateY(-2px);

            i {
                color: white;
            }
        }

        &:active {
            transform: translateY(0);
        }
    }

    .gestor-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.75rem;
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.05) 0%, rgba(0, 208, 132, 0.05) 100%);
        border-radius: 10px;
        color: #495057;
        font-weight: 500;
        font-size: 0.875rem;

        i {
            color: #1f7bff;
        }
    }

    /* Cards de Usuários */
    .card-usuario {
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
        border-radius: 12px;
        padding: 1.25rem;
        margin-bottom: 1rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(31, 123, 255, 0.1);
        transition: all 0.3s ease;
        animation: fadeInUp 0.6s ease-out;

        &:hover {
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
            border-color: rgba(31, 123, 255, 0.2);
            transform: translateY(-2px);
        }

        @media (max-width: 768px) {
            padding: 1rem;
        }
    }

    .usuario-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;

        @media (max-width: 576px) {
            flex-wrap: wrap;
            gap: 0.75rem;
        }
    }

    .usuario-info {
        display: flex;
        align-items: center;
        gap: 0.875rem;
        flex: 1;
    }

    .usuario-avatar {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.3);
        flex-shrink: 0;

        i {
            font-size: 1.2rem;
            color: white;
        }
    }

    .usuario-nome {
        font-size: 1.05rem;
        font-weight: 700;
        color: #2d3748;
        margin: 0;
        line-height: 1.2;
    }

    .usuario-actions {
        display: flex;
        gap: 0.5rem;
        flex-shrink: 0;
    }

    .btn-action {
        width: 36px;
        height: 36px;
        border-radius: 10px;
        border: 2px solid;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        cursor: pointer;
        background: white;

        i {
            font-size: 0.9rem;
        }

        &:hover {
            transform: translateY(-2px);
        }

        &:active {
            transform: translateY(0);
        }
    }

    .btn-edit {
        border-color: #1f7bff;

        i {
            color: #1f7bff;
        }

        &:hover {
            background: linear-gradient(135deg, #1f7bff 0%, #0056d2 100%);
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.3);

            i {
                color: white;
            }
        }
    }

    .btn-delete {
        border-color: #dc3545;

        i {
            color: #dc3545;
        }

        &:hover {
            background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);

            i {
                color: white;
            }
        }
    }

    .usuario-divider {
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(31, 123, 255, 0.2), transparent);
        margin-bottom: 1rem;
    }

    .usuario-permissoes {
        h4.permissoes-title {
            font-size: 0.95rem;
            font-weight: 700;
            color: #2d3748;
            margin-bottom: 1rem;
            display: flex;
            align-items: center;

            i {
                color: #1f7bff;
            }
        }
    }

    .permissao-item {
        padding: 0.625rem;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 10px;
        border: 1px solid #e9ecef;
        transition: all 0.3s ease;

        &:hover {
            background: rgba(248, 249, 250, 0.9);
            border-color: #cbd5e0;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        }
    }

    .permissao-checkbox {
        display: flex;
        align-items: center;
        cursor: pointer;
        margin: 0;
        width: 100%;

        input[type="checkbox"] {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;

            &:checked ~ .checkbox-custom {
                background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
                border-color: transparent;

                &::after {
                    display: block;
                }
            }
        }

        .checkbox-custom {
            width: 20px;
            height: 20px;
            border: 2px solid #cbd5e0;
            border-radius: 5px;
            margin-right: 0.625rem;
            position: relative;
            transition: all 0.3s ease;
            flex-shrink: 0;
            background: white;

            &::after {
                content: '';
                position: absolute;
                display: none;
                left: 6px;
                top: 2px;
                width: 5px;
                height: 10px;
                border: solid white;
                border-width: 0 2px 2px 0;
                transform: rotate(45deg);
            }
        }

        &:hover .checkbox-custom {
            border-color: #1f7bff;
            box-shadow: 0 0 0 3px rgba(31, 123, 255, 0.1);
        }

        .produto-label {
            font-weight: 600;
            font-size: 0.875rem;
            display: flex;
            align-items: center;
            flex: 1;

            i {
                opacity: 0.7;
                font-size: 0.85rem;
            }
        }
    }

    /* Empty State */
    .empty-state {
        animation: fadeInUp 0.6s ease-out;

        i {
            color: #cbd5e0;
        }

        .empty-message {
            font-size: 1.25rem;
            color: #6c757d;
            font-weight: 600;
        }
    }

    .permissao-checkbox {
        input[type="checkbox"]:disabled ~ .checkbox-custom {
            border-color: #e5e7eb;
            background: #f3f4f6;
            box-shadow: none;
        }

        input[type="checkbox"]:disabled ~ .produto-label {
            color: #9ca3af !important;
        }

        input[type="checkbox"]:disabled ~ .checkbox-custom,
        input[type="checkbox"]:disabled ~ .produto-label {
            cursor: not-allowed;
        }
    }

    .permissao-item:hover .permissao-checkbox input[type="checkbox"]:disabled ~ .checkbox-custom {
        border-color: #e5e7eb;
        box-shadow: none;
    }

    .modern-table-card {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        border-radius: 16px;
        border: 1px solid rgba(31, 123, 255, 0.12);
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
        overflow: hidden;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .modern-table-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 20px 48px rgba(15, 23, 42, 0.12);
    }

    .custom-table-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1.5rem;
        padding: 1.5rem 1.75rem;
        border-bottom: 1px solid rgba(15, 23, 42, 0.06);
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.85) 0%, rgba(248, 250, 252, 0.85) 100%);
        flex-wrap: wrap;
    }

    .header-group {
        display: flex;
        align-items: center;
        gap: 1.25rem;
        flex: 0 1 auto;
        min-width: 0;
    }

    .header-icon {
        width: 54px;
        height: 54px;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.1) 0%, rgba(0, 208, 132, 0.1) 100%);
        color: #1f7bff;
        font-size: 1.5rem;
        box-shadow: 0 8px 18px rgba(31, 123, 255, 0.12);
    }

    .header-label {
        display: inline-flex;
        align-items: center;
        font-weight: 600;
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: #6b7280;
    }

    .header-title {
        margin: 0;
        font-weight: 700;
        font-size: 1.35rem;
        color: #1f2937;
        line-height: 1.2;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem 1.5rem;
        border-radius: 12px;
        font-weight: 600;
        font-size: 0.95rem;
        border: none;
        cursor: pointer;
        transition: all 0.25s ease;
        position: relative;
        overflow: hidden;
        box-shadow: 0 10px 24px rgba(31, 123, 255, 0.25);
    }

    .modern-btn::before {
        content: '';
        position: absolute;
        inset: -60% auto auto -60%;
        width: 220%;
        height: 220%;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.25);
        transform: scale(0);
        transition: transform 0.6s ease;
    }

    .modern-btn:hover::before {
        transform: scale(1);
    }

    .modern-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 18px 28px rgba(31, 123, 255, 0.35);
    }

    .modern-btn:active {
        transform: translateY(0);
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #1f7bff 0%, #0e4fd6 100%);
        color: #ffffff;
    }

    .modern-table-content {
        padding: 1.5rem 1.75rem 1.75rem;
    }

    .modern-table-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.75rem;
        padding: 3rem 1rem;
        border-radius: 14px;
        background: rgba(248, 250, 252, 0.9);
        color: #4b5563;
        text-align: center;
        font-weight: 500;
        animation: fadeInUp 0.4s ease;
    }

    .modern-table-state.loading i {
        font-size: 2rem;
        background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    .modern-table-state.empty svg {
        color: #94a3b8;
    }

    .modern-table-state.empty h5 {
        margin: 0;
        font-size: 1.15rem;
        font-weight: 700;
        color: #1f2937;
    }

    .modern-table-state.empty p {
        margin: 0;
        font-size: 0.95rem;
        color: #6b7280;
    }

    .table-wrapper {
        width: 100%;
        overflow-x: auto;
        border-radius: 14px;
        border: 1px solid rgba(226, 232, 240, 0.8);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
    }

    .custom-table {
        width: 100%;
        border-collapse: collapse;
        min-width: 420px;
        background: #ffffff;
    }

    .custom-table thead {
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.08) 0%, rgba(0, 208, 132, 0.08) 100%);
    }

    .custom-table th {
        text-transform: uppercase;
        font-weight: 700;
        font-size: 0.75rem;
        letter-spacing: 0.08em;
        padding: 1rem 1.25rem;
        color: #4b5563;
        border-bottom: 1px solid rgba(15, 23, 42, 0.06);
    }

    .custom-table td {
        padding: 1.1rem 1.25rem;
        font-size: 0.95rem;
        font-weight: 600;
        color: #1f2937;
        border-bottom: 1px solid rgba(226, 232, 240, 0.9);
        background: rgba(255, 255, 255, 0.85);
    }

    .custom-table tbody tr:hover {
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.05) 0%, rgba(0, 208, 132, 0.05) 100%);
        transform: translateY(-1px);
        transition: all 0.2s ease;
    }

    .assinante-nome {
        display: block;
        font-weight: 700;
        color: #1f2937;
    }

    .assinante-email {
        color: #1f7bff;
        font-weight: 600;
    }

    .assinante-login {
        display: block;
        font-size: 0.8rem;
        color: #6b7280;
        font-weight: 500;
    }

    .badge-status {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0.25rem 0.85rem;
        border-radius: 999px;
        font-size: 0.8rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
    }

    .badge-ativo {
        background-color: #dcfce7;
        color: #16a34a;
    }

    .badge-inativo {
        background-color: #fee2e2;
        color: #b91c1c;
    }

    .action-buttons {
        display: inline-flex;
        gap: 0.5rem;
        align-items: center;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 0.45rem;
        padding: 0.5rem 0.9rem;
        border-radius: 10px;
        font-weight: 600;
        font-size: 0.85rem;
        border: 2px solid transparent;
        cursor: pointer;
        transition: all 0.25s ease;
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.08) 0%, rgba(0, 208, 132, 0.08) 100%);
        color: #14532d;
    }

    .action-btn svg {
        pointer-events: none;
    }

    .action-btn::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    .action-btn:hover {
        transform: translateY(-1px);
        border-color: rgba(31, 123, 255, 0.4);
        box-shadow: 0 10px 22px rgba(31, 123, 255, 0.18);
    }

    .action-btn-view {
        position: relative;
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        border-color: transparent;
        box-shadow: 0 10px 24px rgba(16, 185, 129, 0.2);
    }

    .action-btn-view:hover {
        transform: translateY(-2px);
        box-shadow: 0 18px 28px rgba(16, 185, 129, 0.3);
    }

    .action-text {
        display: inline-block;
    }

    @media (max-width: 768px) {
        .custom-table,
        .custom-table thead,
        .custom-table tbody,
        .custom-table th,
        .custom-table td,
        .custom-table tr {
            display: block;
            width: 100%;
        }

        .custom-table thead {
            display: none;
        }

        .custom-table tr {
            margin-bottom: 1rem;
            border-radius: 12px;
            box-shadow: 0 10px 26px rgba(15, 23, 42, 0.12);
            overflow: hidden;
        }

        .custom-table td {
            padding: 1rem 1.1rem;
            border: none;
            border-bottom: 1px solid rgba(226, 232, 240, 0.6);
            position: relative;
        }

        .custom-table td::before {
            content: attr(data-label);
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            font-size: 0.7rem;
            color: #6b7280;
            display: block;
            margin-bottom: 0.4rem;
        }

        .custom-table td:last-child {
            border-bottom: none;
        }

        .action-text {
            display: none;
        }

        .modern-table-card {
            border-radius: 12px;
        }

        .custom-table-header {
            flex-direction: column;
            align-items: flex-start;
            padding: 1.25rem 1.4rem;
        }

        .modern-btn {
            width: 100%;
            justify-content: center;
        }

        .modern-table-content {
            padding: 1.25rem 1.4rem 1.5rem;
        }
    }

    [data-bs-theme="dark"] .modern-table-card {
        background: linear-gradient(135deg, #1a2236 0%, #111827 100%);
        border-color: rgba(59, 130, 246, 0.2);
        box-shadow: 0 16px 36px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .custom-table-header {
        background: linear-gradient(135deg, rgba(17, 24, 39, 0.9) 0%, rgba(15, 23, 42, 0.9) 100%);
        border-bottom-color: rgba(148, 163, 184, 0.15);
    }

    [data-bs-theme="dark"] .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.25) 0%, rgba(16, 185, 129, 0.25) 100%);
        color: #93c5fd;
        box-shadow: 0 10px 24px rgba(59, 130, 246, 0.25);
    }

    [data-bs-theme="dark"] .header-label {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .header-title {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .modern-btn-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 16px 32px rgba(59, 130, 246, 0.35);
    }

    [data-bs-theme="dark"] .modern-table-content {
        background: linear-gradient(135deg, rgba(17, 24, 39, 0.9) 0%, rgba(15, 23, 42, 0.9) 100%);
    }

    [data-bs-theme="dark"] .modern-table-state {
        background: rgba(30, 41, 59, 0.65);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-table-state.empty svg {
        color: #475569;
    }

    [data-bs-theme="dark"] .modern-table-state.empty h5 {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .modern-table-state.empty p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .table-wrapper {
        border-color: rgba(59, 130, 246, 0.16);
        background: rgba(17, 24, 39, 0.8);
    }

    [data-bs-theme="dark"] .custom-table {
        background: transparent;
    }

    [data-bs-theme="dark"] .custom-table th {
        color: #94a3b8;
        border-bottom-color: rgba(148, 163, 184, 0.12);
    }

    [data-bs-theme="dark"] .custom-table td {
        color: #e2e8f0;
        background: rgba(30, 41, 59, 0.65);
        border-bottom-color: rgba(51, 65, 85, 0.8);
    }

    [data-bs-theme="dark"] .custom-table tbody tr:hover {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.16) 0%, rgba(16, 185, 129, 0.16) 100%);
    }

    [data-bs-theme="dark"] .assinante-email {
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .assinante-login {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .badge-ativo {
        background-color: rgba(22, 163, 74, 0.25);
        color: #bbf7d0;
    }

    [data-bs-theme="dark"] .badge-inativo {
        background-color: rgba(185, 28, 28, 0.3);
        color: #fecaca;
    }

    [data-bs-theme="dark"] .action-btn-view {
        box-shadow: 0 16px 28px rgba(16, 185, 129, 0.35);
    }

    [data-bs-theme="dark"] .custom-table td::before {
        color: #9ca3af;
    }

    /* Responsividade */
    @media (max-width: 992px) {
        .produto-stat {
            padding: 0.375rem 0;

            .produto-nome,
            .produto-valor {
                font-size: 0.8rem;
            }
        }

        .total-usuarios-card {
            .total-number {
                font-size: 2rem;
            }

            i.fa-users {
                font-size: 1.75rem;
            }
        }
    }

    @media (max-width: 768px) {
        .gestor-nome,
        .usuario-nome {
            font-size: 1rem;
        }

        .gestor-avatar,
        .usuario-avatar {
            width: 38px;
            height: 38px;

            i {
                font-size: 1.1rem;
            }
        }

        .btn-action,
        .btn-edit-gestor {
            width: 32px;
            height: 32px;

            i {
                font-size: 0.85rem;
            }
        }

        .permissoes-title {
            font-size: 0.9rem !important;
        }
    }

    @media (max-width: 576px) {
        .total-usuarios-card {
            .total-number {
                font-size: 1.75rem;
            }

            i.fa-users {
                font-size: 1.5rem;
            }
        }

        .usuario-actions,
        .gestor-header {
            width: 100%;
            justify-content: center;
        }

        .permissao-checkbox .produto-label {
            font-size: 0.8rem;
        }
    }

    /* ========== DARK THEME ========== */
    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1a1f2e 0%, #252b3d 100%);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    [data-bs-theme="dark"] .modern-title {
        color: #ffffff;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .loading-spinner {
        i {
            background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }

        p {
            color: #d1d5db;
        }
    }

    [data-bs-theme="dark"] .card-totais {
        background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
        border-color: rgba(96, 165, 250, 0.2);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);

        &:hover {
            box-shadow: 0 8px 24px rgba(96, 165, 250, 0.2);
            border-color: rgba(96, 165, 250, 0.3);
        }
    }

    [data-bs-theme="dark"] .produto-stat {
        i {
            color: #34d399;
        }

        .produto-nome {
            color: #f3f4f6;
        }

        .produto-valor {
            color: #60a5fa;
        }

        &:hover .produto-valor {
            color: #34d399;
        }
    }

    [data-bs-theme="dark"] .total-usuarios-card {
        i.fa-users {
            background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }

        .total-label {
            color: #9ca3af;
        }

        .total-number {
            background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }
    }

    [data-bs-theme="dark"] .btn-novo-usuario {
        background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
        box-shadow: 0 4px 12px rgba(96, 165, 250, 0.4);

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            box-shadow: 0 6px 20px rgba(96, 165, 250, 0.5);
        }
    }

    [data-bs-theme="dark"] .card-gestor {
        background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
        border-color: rgba(251, 191, 36, 0.3);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);

        &::before {
            background: linear-gradient(90deg, #fbbf24 0%, #f59e0b 100%);
        }

        &:hover {
            box-shadow: 0 8px 24px rgba(251, 191, 36, 0.2);
            border-color: rgba(251, 191, 36, 0.4);
        }
    }

    [data-bs-theme="dark"] .gestor-avatar {
        background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
        box-shadow: 0 4px 12px rgba(251, 191, 36, 0.4);
    }

    [data-bs-theme="dark"] .gestor-nome {
        color: #ffffff;
    }

    [data-bs-theme="dark"] .label-gestor {
        background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
        box-shadow: 0 2px 8px rgba(96, 165, 250, 0.3);
    }

    [data-bs-theme="dark"] .btn-edit-gestor {
        background: linear-gradient(135deg, #2d3548 0%, #353d52 100%);
        border-color: rgba(255, 255, 255, 0.1);

        i, svg {
            color: #60a5fa;
            fill: #60a5fa;
        }

        &:hover {
            background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
            border-color: #60a5fa;
            box-shadow: 0 4px 12px rgba(96, 165, 250, 0.4);

            i, svg {
                color: white;
                fill: white;
            }
        }
    }

    [data-bs-theme="dark"] .gestor-footer {
        background: linear-gradient(135deg, rgba(96, 165, 250, 0.1) 0%, rgba(52, 211, 153, 0.1) 100%);
        color: #d1d5db;

        i {
            color: #60a5fa;
        }
    }

    [data-bs-theme="dark"] .card-usuario {
        background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
        border-color: rgba(96, 165, 250, 0.2);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);

        &:hover {
            box-shadow: 0 8px 24px rgba(96, 165, 250, 0.2);
            border-color: rgba(96, 165, 250, 0.3);
        }
    }

    [data-bs-theme="dark"] .usuario-avatar {
        background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
        box-shadow: 0 2px 8px rgba(96, 165, 250, 0.4);
    }

    [data-bs-theme="dark"] .usuario-nome {
        color: #ffffff;
    }

    [data-bs-theme="dark"] .label-admin {
        background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
        color: white;
        padding: 0.375rem 0.75rem;
        border-radius: 16px;
        font-weight: 600;
        font-size: 0.75rem;
        box-shadow: 0 2px 8px rgba(96, 165, 250, 0.3);
        display: inline-flex;
        align-items: center;
    }

    [data-bs-theme="dark"] .btn-action {
        background: linear-gradient(135deg, #2d3548 0%, #353d52 100%);

        &:hover {
            transform: translateY(-2px);
        }
    }

    [data-bs-theme="dark"] .btn-edit {
        border-color: rgba(96, 165, 250, 0.3);

        i, svg {
            color: #60a5fa;
            fill: #60a5fa;
        }

        &:hover {
            background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
            border-color: #60a5fa;
            box-shadow: 0 4px 12px rgba(96, 165, 250, 0.4);

            i, svg {
                color: white;
                fill: white;
            }
        }
    }

    [data-bs-theme="dark"] .btn-delete {
        border-color: rgba(248, 113, 113, 0.3);

        i {
            color: #f87171;
        }

        &:hover {
            background: linear-gradient(135deg, #f87171 0%, #ef4444 100%);
            border-color: #f87171;
            box-shadow: 0 4px 12px rgba(248, 113, 113, 0.4);

            i {
                color: white;
            }
        }
    }

    [data-bs-theme="dark"] .usuario-divider {
        background: linear-gradient(90deg, transparent, rgba(96, 165, 250, 0.2), transparent);
    }

    [data-bs-theme="dark"] .usuario-permissoes {
        h4.permissoes-title {
            color: #f3f4f6;

            i {
                color: #60a5fa;
            }
        }
    }

    [data-bs-theme="dark"] .permissao-item {
        background: rgba(45, 53, 72, 0.5);
        border-color: rgba(255, 255, 255, 0.1);

        &:hover {
            background: rgba(53, 61, 82, 0.6);
            border-color: rgba(96, 165, 250, 0.2);
            box-shadow: 0 2px 8px rgba(96, 165, 250, 0.1);
        }
    }

    [data-bs-theme="dark"] .permissao-checkbox {
        input[type="checkbox"] {
            &:checked ~ .checkbox-custom {
                background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
                border-color: transparent;
            }
        }

        .checkbox-custom {
            border-color: rgba(255, 255, 255, 0.2);
            background: rgba(45, 53, 72, 0.5);
        }

        &:hover .checkbox-custom {
            border-color: #60a5fa;
            box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.15);
        }

        .produto-label {
            color: #e5e7eb;

            i {
                opacity: 0.8;
            }
        }

        input[type="checkbox"]:disabled ~ .checkbox-custom {
            border-color: rgba(255, 255, 255, 0.1);
            background: rgba(30, 35, 48, 0.5);
        }

        input[type="checkbox"]:disabled ~ .produto-label {
            color: #6b7280 !important;
        }
    }

    [data-bs-theme="dark"] .permissao-item:hover .permissao-checkbox input[type="checkbox"]:disabled ~ .checkbox-custom {
        border-color: rgba(255, 255, 255, 0.1);
        box-shadow: none;
    }

    [data-bs-theme="dark"] .empty-state {
        i {
            color: #4b5563;
        }

        .empty-message {
            color: #9ca3af;
        }
    }

    [data-bs-theme="dark"] .tyn-footer {
        background: linear-gradient(135deg, #1a1f2e 0%, #252b3d 100%);
        border-top: 1px solid rgba(255, 255, 255, 0.1);

        .bg-white {
            background: transparent !important;
        }

        p {
            color: #d1d5db;

            a {
                color: #60a5fa;

                &:hover {
                    color: #34d399;
                }
            }
        }
    }

    /* Estilos das Tabs */
    .tabs-header {
        position: sticky;
        top: 0;
        z-index: 20;
        padding: 0.85rem 1.5rem 0.65rem;
        backdrop-filter: blur(8px);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        flex-wrap: wrap;
    }

    .nav-tabs {
        border-bottom: none;
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin: 0;
        padding: 0;
        flex-grow: 1;
        justify-content: center;
    }

    .nav-tabs .nav-link {
        border: 1px solid transparent;
        background: rgba(248, 250, 252, 0.75);
        color: #475569;
        font-weight: 600;
        padding: 0.55rem 1.2rem;
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        gap: 0.45rem;
        transition: all 0.2s ease;
        box-shadow: inset 0 0 0 1px rgba(226, 232, 240, 0.8);
    }

    .nav-tabs .nav-link:hover {
        background: rgba(37, 99, 235, 0.12);
        color: #1d4ed8;
        box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.25);
    }

    .nav-tabs .nav-link.active {
        background: linear-gradient(135deg, #2563EB 0%, #22c55e 100%);
        color: #fff;
        box-shadow: 0 12px 26px rgba(37, 99, 235, 0.28);
        border-color: transparent;
    }

    [data-bs-theme="dark"] .tabs-header {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.95) 100%);
        border-bottom: 1px solid rgba(51, 65, 85, 0.8);
    }

    [data-bs-theme="dark"] .nav-tabs {
        border-bottom: none;
    }

    [data-bs-theme="dark"] .nav-tabs .nav-link {
        background: rgba(30, 41, 59, 0.85);
        color: #cbd5f5;
        box-shadow: inset 0 0 0 1px rgba(51, 65, 85, 0.8);
        border-color: transparent;
    }

    [data-bs-theme="dark"] .nav-tabs .nav-link:hover {
        background: rgba(59, 130, 246, 0.25);
        color: #93c5fd;
        box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.4);
    }

    [data-bs-theme="dark"] .nav-tabs .nav-link.active {
        background: linear-gradient(135deg, #1d4ed8 0%, #10b981 100%);
        color: #f8fafc;
        box-shadow: 0 14px 32px rgba(15, 118, 110, 0.35);
    }

    /* Select do Contrato */
    .select-contrato {
        min-width: 240px;
        max-width: 400px;
        width: auto;
        flex: 0 1 auto;
        padding: 0.75rem 1rem;
        font-size: 0.95rem;
        font-weight: 600;
        color: #1f2937;
        border: 2px solid rgba(31, 123, 255, 0.2);
        border-radius: 12px;
        background: #ffffff;
        transition: all 0.25s ease;
        cursor: pointer;
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%231f7bff' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 1rem center;
        background-size: 12px;
        padding-right: 2.5rem;
    }

    .select-contrato:hover {
        border-color: rgba(31, 123, 255, 0.4);
        box-shadow: 0 4px 12px rgba(31, 123, 255, 0.15);
    }

    .select-contrato:focus {
        outline: none;
        border-color: #1f7bff;
        box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.15);
    }

    [data-bs-theme="dark"] .select-contrato {
        background: rgba(30, 41, 59, 0.85);
        border-color: rgba(96, 165, 250, 0.3);
        color: #f3f4f6;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2360a5fa' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    }

    [data-bs-theme="dark"] .select-contrato:hover {
        border-color: rgba(96, 165, 250, 0.5);
        box-shadow: 0 4px 12px rgba(96, 165, 250, 0.2);
    }

    [data-bs-theme="dark"] .select-contrato:focus {
        border-color: #60a5fa;
        box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.2);
    }

    /* Melhorias no Header do Contrato */
    .custom-table-header {
        @media (max-width: 992px) {
            flex-wrap: wrap;
            gap: 1rem;
        }

        @media (max-width: 768px) {
            flex-direction: column;
            align-items: stretch;
            padding: 1.25rem 1.4rem;
            gap: 1.25rem;
        }
    }

    .header-group {
        @media (max-width: 768px) {
            width: 100%;
            flex-wrap: wrap;
            gap: 1rem;
        }
    }

    .select-contrato {
        @media (max-width: 992px) {
            min-width: 240px;
            max-width: 100%;
            width: 100%;
        }

        @media (max-width: 768px) {
            min-width: 100%;
            width: 100%;
            font-size: 0.9rem;
            padding: 0.7rem 0.9rem;
            padding-right: 2.5rem;
        }

        @media (max-width: 576px) {
            font-size: 0.85rem;
            padding: 0.65rem 0.85rem;
            padding-right: 2.5rem;
        }
    }

    /* Melhorias no Card Totais */
    .card-totais {
        @media (max-width: 992px) {
            .row {
                flex-direction: column;
            }

            .col-md-9 {
                margin-bottom: 1.5rem;
            }

            .col-md-3 {
                width: 100%;
            }
        }

        @media (max-width: 768px) {
            padding: 1rem;
        }
    }

    /* Melhorias nas Tabs */
    .tabs-header {
        @media (max-width: 992px) {
            padding: 0.75rem 1.25rem 0.65rem;
        }

        @media (max-width: 768px) {
            padding: 0.75rem 1rem 0.65rem;
            position: relative;
            gap: 0.75rem;
        }

        @media (max-width: 576px) {
            padding: 0.65rem 0.75rem 0.55rem;
        }
    }

    .nav-tabs {
        @media (max-width: 992px) {
            gap: 0.4rem;
        }

        @media (max-width: 768px) {
            width: 100%;
            justify-content: stretch;
            gap: 0.35rem;
        }

        @media (max-width: 576px) {
            gap: 0.3rem;
        }

        .nav-link {
            @media (max-width: 992px) {
                padding: 0.5rem 1rem;
                font-size: 0.9rem;
            }

            @media (max-width: 768px) {
                flex: 1;
                text-align: center;
                padding: 0.5rem 0.75rem;
                font-size: 0.85rem;
                min-width: 0;
            }

            @media (max-width: 576px) {
                padding: 0.45rem 0.65rem;
                font-size: 0.8rem;
            }
        }
    }

    /* Melhorias no Grid de Produtos */
    .card-totais .row {
        @media (max-width: 768px) {
            .col-lg-6 {
                margin-bottom: 0.75rem;
            }
        }
    }

    /* Melhorias no Botão Novo Usuário */
    .btn-novo-usuario {
        @media (max-width: 576px) {
            padding: 0.75rem 1rem;
            font-size: 0.8rem;
        }
    }

    /* Melhorias no Card Gestor */
    .gestor-actions {
        @media (max-width: 576px) {
            width: 100%;
            justify-content: flex-end;
            margin-top: 0.5rem;
        }
    }

    /* Melhorias no Card Usuário */
    .usuario-permissoes {
        @media (max-width: 768px) {
            .row {
                .col-md-6 {
                    margin-bottom: 0.75rem;
                }
            }
        }
    }
</style>

